module.exports = __webpack_public_path__ + "static/media/answerPIC15.1030222d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPIC15.png
// module id = 733
// module chunks = 0 1